import "react-toastify/dist/ReactToastify.css"
import styles from "./Contracts.module.scss"

import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { pdf } from "@react-pdf/renderer"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"
import { MergePDF } from "../../utils/MergePDF"

import OTPInput from "../../components/EditableInputs/OTPInput"
import CurrentDateTime from "../../utils/CurrentDateTime"
import { post, get } from "../../utils/api"
import { InvalidContract, getTermsAndConditions } from "./ContractsAPI"
import ContractTemplate from "./ContractTemplate"
import CustomPDFViewer from "../../utils/CustomPDFViewer"
import LoadingSpinner from "../../components/Messages/LoadingSpinner"

const Contracts = () => {
  const { id } = useParams()
  const { debtorID } = useParams()
  const [contract, setContract] = useState({})
  const [contractLines, setContractLines] = useState({})
  const [errorName, setErrorName] = useState("")
  const [errorSurname, setErrorSurname] = useState("")
  const [errorIdno, setErrorIdno] = useState("")
  const [errorRole, setErrorRole] = useState("")
  const [errorCellNo, setErrorCellNo] = useState("")
  const [errorTime, setErrorTime] = useState("")
  const [errorPlace, setErrorPlace] = useState("")
  const [errorOtp, setErrorOtp] = useState("")
  const [disabled, setDisabled] = useState(true)
  const [signedName, SetSignedName] = useState("")
  const [signedSurname, setSignedSurname] = useState("")
  const [signedId, setSignedId] = useState("")
  const [signedRole, setSignedRole] = useState("")
  const [signedCellNo, setSignedCellNo] = useState("")
  const [signedOtp, setSignedOtp] = useState("")
  const [message, setMessage] = useState("")
  const [signedTime, setSignedTime] = useState(new Date().toISOString())
  const [signedPlace, setSignedPlace] = useState("")
  const [agreementCheck, setAgreementCheck] = useState(false)
  const [agreementContact, setAgreementContact] = useState("")
  const [acceptContactErr, setAcceptContactErr] = useState("")
  const [headerImage, setHeaderImage] = useState({})
  const [pdfBlobUrl, setPdfBlobUrl] = useState("")
  const [pdfError, setPdfError] = useState(null)
  const [loadingState, setLoadingState] = useState("loading")

  const sendOTP = async () => {
    const resp = await post("/contracts/set_otp", {
      signedCellNo: signedCellNo,
      uuid: contract.uuid
    })

    if (resp.ok) {
      setDisabled(false)
      setErrorOtp("OTP Sent to your cellphone number")
    } else {
      setErrorOtp("Something went wrong. Try to request a OTP again.")
      setDisabled(true)
    }
    return resp.ok
  }

  const contractAgreementUpdate = async () => {
    const resp = await post("/contracts/contract_complete", {
      uuid: contract.uuid,
      signedName: signedName,
      signedSurname: signedSurname,
      signedId: signedId,
      signedRole: signedRole,
      signedCellNo: signedCellNo,
      signedOtp: signedOtp,
      signedTime: signedTime,
      signedPlace: signedPlace
    })
    if (resp.ok) {
      toast.success("Your response has been succesfully sent.")
      return true
    } else {
      toast.error(
        "We were unable to submit your request due to a server error."
      )
      return false
    }
  }

  const formValidate = e => {
    e.preventDefault()
    let isValid = true
    if (signedName === "") {
      setErrorName("Please enter your name")
      isValid = false
    } else {
      setErrorName("")
    }
    if (signedSurname === "") {
      setErrorSurname("Please enter your surname")
      isValid = false
    } else {
      setErrorSurname("")
    }
    if (signedId.length < 13) {
      setErrorIdno("ID number must be 13 characters long")
      isValid = false
    } else {
      setErrorIdno("")
    }
    if (signedCellNo === "") {
      setErrorCellNo("Please enter your Cell No")
      isValid = false
    } else {
      setErrorCellNo("")
    }
    if (signedRole === "") {
      setErrorRole("Please enter your role")
      isValid = false
    } else {
      setErrorRole("")
    }
    if (signedOtp === "") {
      setErrorOtp("Please enter an OTP Pin")
      isValid = false
    } else {
      setErrorOtp("")
    }
    if (signedTime === "") {
      setErrorTime("Please select a date")
      isValid = false
    } else {
      setErrorTime("")
    }
    if (signedPlace === "") {
      setErrorPlace("Please enter a place")
      isValid = false
    } else {
      setErrorPlace("")
    }
    if (agreementContact === "") {
      setAcceptContactErr("Please enter your full name")
      isValid = false
    } else {
      setAcceptContactErr("")
    }
    if (!agreementCheck) {
      setAcceptContactErr("You must accept the terms")
      isValid = false
    } else {
      setAcceptContactErr("")
    }
    return isValid
  }

  const generateAndSaveCombinedPDF = async signedData => {
    try {
      const contractForPdf = { ...contract, stage: "signed" }

      const contractAndAcceptanceBlob = await pdf(
        <ContractTemplate
          props={contractForPdf}
          line_detail={contractLines}
          headerImages={headerImage.header}
          agreementName={signedData.signedName}
          agreementSurname={signedData.signedSurname}
          agreementID={signedData.signedId}
          agreementRole={signedData.signedRole}
          agreementCell={signedData.signedCellNo}
          agreementPlace={signedData.signedPlace}
          agreementContact={signedData.agreementContact}
        />
      ).toBlob()

      const termsBlob = await getTermsAndConditions(setPdfError)
      if (!termsBlob) {
        toast.error(
          "Could not fetch Terms & Conditions. The final PDF will be incomplete."
        )
        return
      }

      const finalPdfBlob = await MergePDF(contractAndAcceptanceBlob, termsBlob)
      if (!finalPdfBlob) {
        toast.error("Failed to merge PDF documents.")
        return
      }

      const reader = new FileReader()
      reader.readAsDataURL(finalPdfBlob)
      reader.onloadend = async () => {
        const base64data = reader.result
        await post("/contracts/contract_save_pdf_contract", {
          uuid: contract.uuid,
          signed_contract: base64data
        })
        window.location.reload()
      }

      const link = document.createElement("a")
      link.href = window.URL.createObjectURL(finalPdfBlob)
      link.download = "Signed_Contract_" + contract.uuid + ".pdf"
      link.click()
    } catch (error) {
      console.error("Error during final PDF generation:", error)
      toast.error("An error occurred while generating the final PDF.")
    }
  }

  const contractSubmit = async e => {
    if (!formValidate(e)) return

    const otpValid = await otpValidate(contract, signedOtp)
    if (!otpValid) return

    const updateSuccess = await contractAgreementUpdate()
    if (updateSuccess) {
      await generateAndSaveCombinedPDF({
        signedName,
        signedSurname,
        signedId,
        signedRole,
        signedCellNo,
        signedPlace,
        agreementContact
      })
    }
  }

  const otpValidate = async (contract, signedOtp) => {
    const resp = await post("/contracts/validate_otp", {
      signedOtp: signedOtp,
      uuid: contract?.uuid
    })

    if (!resp.ok) {
      setErrorOtp("Something went wrong. Please send OTP again.")
      return false
    }

    const json = await resp.json()
    if (!json.exists) {
      setErrorOtp("The OTP you entered is invalid")
    } else {
      setErrorOtp("")
    }

    return json.exists
  }

  useEffect(() => {
    const fetchAllData = async () => {
      setLoadingState("loading")
      try {
        const [contractResp, linesResp, headerResp] = await Promise.all([
          get(`/contracts/${id}/${debtorID}`),
          get(`/contract/${id}/${debtorID}/contract_lines`),
          get(`/quotation/config/header_image`)
        ])

        if (contractResp.ok && linesResp.ok && headerResp.ok) {
          const contractData = await contractResp.json()
          if (
            contractData &&
            typeof contractData === "object" &&
            Object.keys(contractData).length > 0
          ) {
            setContract(contractData)
            setContractLines(await linesResp.json())
            setHeaderImage(await headerResp.json())
            setLoadingState("generating_pdf")
          } else {
            setLoadingState("error")
          }
        } else {
          setLoadingState("error")
        }
      } catch (error) {
        console.error("Failed to fetch contract data:", error)
        setLoadingState("error")
      }
    }

    fetchAllData()
  }, [id, debtorID])

  useEffect(() => {
    const generateAndMergePdf = async () => {
      if (loadingState !== "generating_pdf") return

      setPdfError(null)
      try {
        const contractBlob = await pdf(
          <ContractTemplate
            props={contract}
            line_detail={contractLines}
            headerImages={headerImage.header}
            agreementName={contract.signed_name}
            agreementSurname={contract.signed_surname}
            agreementID={contract.signed_id}
            agreementRole={contract.signed_role}
            agreementCell={contract.signed_cell}
            agreementPlace={contract.signed_place}
            agreementContact={`${contract.signed_name} ${contract.signed_surname}`}
          />
        ).toBlob()

        const termsBlob = await getTermsAndConditions(setPdfError)

        if (contractBlob && termsBlob) {
          const mergedBlob = await MergePDF(contractBlob, termsBlob)
          if (mergedBlob) {
            setPdfBlobUrl(URL.createObjectURL(mergedBlob))
            setLoadingState("success")
          } else {
            setPdfError("Failed to merge PDF documents.")
            setLoadingState("error")
          }
        } else {
          setPdfError(
            "Failed to generate one or both PDF documents for merging."
          )
          setLoadingState("error")
        }
      } catch (error) {
        console.error("PDF Generation Error:", error)
        setPdfError("An error occurred while generating the PDF.")
        setLoadingState("error")
      }
    }

    generateAndMergePdf()

    return () => {
      if (pdfBlobUrl) {
        URL.revokeObjectURL(pdfBlobUrl)
      }
    }
  }, [loadingState, contract, contractLines, headerImage])

  if (loadingState === "loading") {
    return <LoadingSpinner text="Loading contract..." />
  }

  if (loadingState === "generating_pdf") {
    return <LoadingSpinner text="Generating contract PDF..." />
  }

  if (loadingState === "error") {
    return (
      <div className={styles.centeredMessageContainer}>
        <div>
          <InvalidContract />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.contractPage}>
      {contract.stage !== "signed" ? (
        <form onSubmit={contractSubmit} className={styles.contractForm}>
          <div className={styles.form_container}>
            <h2 className={styles.heading}>PART B</h2>
            <label htmlFor="firstname">Name:</label>
            <div>
              <input
                id="firstname"
                type="text"
                onChange={event => SetSignedName(event.target.value)}
              />
              <span className={styles.errormsg}>{errorName}</span>
            </div>

            <label htmlFor="surname">Surname:</label>
            <div>
              <input
                id="surname"
                type="text"
                onChange={event => setSignedSurname(event.target.value)}
              />
              <span className={styles.errormsg}>{errorSurname}</span>
            </div>

            <label htmlFor="id_no">ID No:</label>
            <div>
              <input
                id="id_no"
                type="text"
                onChange={event => setSignedId(event.target.value)}
                pattern="^-?[0-9]\d*"
                maxLength="13"
              />
              <span className={styles.errormsg}>{errorIdno}</span>
            </div>

            <label htmlFor="role">Role:</label>
            <div>
              <input
                id="role"
                type="text"
                onChange={event => setSignedRole(event.target.value)}
              />
              <span className={styles.errormsg}>{errorRole}</span>
            </div>

            <label htmlFor="cellphone">Cellphone No:</label>
            <div className={styles.cellphone_group}>
              <input
                id="cellphone"
                type="text"
                onChange={event => setSignedCellNo(event.target.value)}
              />
              <button
                type="button"
                className={styles.btnotp_request}
                onClick={sendOTP}
              >
                <FontAwesomeIcon icon={faCheck} color="white" />
                SEND OTP
              </button>
            </div>
            <div></div>
            <span className={styles.errormsg}>{errorCellNo}</span>

            <label htmlFor="otp">OTP Pin:</label>
            <div>
              <OTPInput
                state={[signedOtp, setSignedOtp]}
                setMessage={setMessage}
                disabled={disabled}
              />
              <span className={styles.errormsg}>{errorOtp || message}</span>
            </div>

            <label htmlFor="signed_time">Signed Time:</label>
            <div>
              <input
                id="signed_time"
                type="date"
                defaultValue={CurrentDateTime()}
                onChange={event => setSignedTime(event.target.value)}
              />
              <span className={styles.errormsg}>{errorTime}</span>
            </div>

            <label htmlFor="signed_place">Signed Place:</label>
            <div>
              <input
                id="signed_place"
                type="text"
                onChange={event => setSignedPlace(event.target.value)}
              />
              <span className={styles.errormsg}>{errorPlace}</span>
            </div>

            <label htmlFor="address">Address:</label>
            <div>
              <textarea
                id="address"
                cols={1}
                rows={4}
                defaultValue={contract.signed_address}
                disabled={true}
              />
            </div>

            <div className={styles.acceptance}>
              <h4>Acceptance of Terms of Agreement</h4>
              
              <div className={styles.acceptance_content}>
                <div className={styles.acceptance_name_field}>
                  <label htmlFor="agreement_contact">Full Name:</label>
                  <input
                    id="agreement_contact"
                    name="agreement_contact"
                    type="text"
                    placeholder="Enter your full name"
                    onChange={event => setAgreementContact(event.target.value)}
                    required={true}
                  />
                </div>
                <div className={styles.acceptance_text}>
                  By clicking on the accept button, I confirm that the information supplied is correct, 
                  that I have read and accept the terms of this GoodX Software Standard Licence, 
                  Services & Operator Agreement read together with the General Terms & Conditions, 
                  Policies and Standard Operating Procedures as amended from time to time on the 
                  official GoodX website, and that I have the authority to sign on behalf of the Client.
                </div>
                <div className={styles.acceptance_checkbox_row}>
                  <input
                    type="checkbox"
                    id="agreement_checked"
                    name="agreement_checked"
                    onChange={() => setAgreementCheck(!agreementCheck)}
                    required={true}
                  />
                  <label htmlFor="agreement_checked">
                    I agree to the terms and conditions stated above
                  </label>
                </div>
              </div>

              <span className={styles.acceptance_err}>{acceptContactErr}</span>
            </div>

            <button type="submit" className={styles.btn_submit}>
              <FontAwesomeIcon icon={faCheck} color="white" />
              Save / Submit
            </button>
            <ToastContainer />
          </div>
        </form>
      ) : (
        <div className={styles.contractForm}>
          <div className={styles.signedMessage}>
            <h3>Contract Already Signed</h3>
            <p>
              This contract has already been signed and submitted. You can view
              the final document on the right.
            </p>
          </div>
        </div>
      )}
      <div className={styles.pdfViewerContainer}>
        {pdfError ? (
          <div>Error generating PDF: {pdfError}</div>
        ) : pdfBlobUrl ? (
          <CustomPDFViewer fileUrl={pdfBlobUrl} />
        ) : (
          <LoadingSpinner text="Generating contract PDF..." />
        )}
      </div>
    </div>
  )
}

export default Contracts
